/*import { useState, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom";
import API_URL from "../config";


const RULES = [
  { key: "length",   label: "8 caractères minimum",      test: (p) => p.length >= 8 },
  { key: "upper",    label: "1 lettre majuscule",         test: (p) => /[A-Z]/.test(p) },
  { key: "digit",    label: "1 chiffre",                  test: (p) => /[0-9]/.test(p) },
  { key: "special",  label: "1 caractère spécial (!@#…)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

function passwordStrength(password) {
  const passed = RULES.filter((r) => r.test(password)).length;
  if (passed <= 1) return { score: 1, label: "Très faible", color: "#dc2626" };
  if (passed === 2) return { score: 2, label: "Faible",      color: "#f59e0b" };
  if (passed === 3) return { score: 3, label: "Moyen",       color: "#3b82f6" };
  return               { score: 4, label: "Fort",        color: "#16a34a" };
}


function generateCaptcha() {
  const a = Math.floor(Math.random() * 10) + 1;
  const b = Math.floor(Math.random() * 10) + 1;
  return { question: `${a} + ${b}`, answer: String(a + b) };
}

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    prenom: "", nom: "", username: "", email: "",
    dateNaissance: "", password: "", confirmPassword: "",
  });
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);


  const [captcha, setCaptcha]       = useState(generateCaptcha);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState(false);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));


  const strength   = useMemo(() => passwordStrength(form.password), [form.password]);
  const rulesState = useMemo(() => RULES.map((r) => ({ ...r, ok: r.test(form.password) })), [form.password]);
  const allRulesOk = rulesState.every((r) => r.ok);

  const handleSubmit = async (e) => {
    e.preventDefault();

  
    if (captchaInput.trim() !== captcha.answer) {
      setCaptchaError(true);
      setCaptcha(generateCaptcha());
      setCaptchaInput("");
      return;
    }
    setCaptchaError(false);


    if (!allRulesOk) return setError("Le mot de passe ne respecte pas toutes les règles.");
    if (form.password !== form.confirmPassword) return setError("Les mots de passe ne correspondent pas.");

    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: form.username, email: form.email, password: form.password,
          nom: form.nom, prenom: form.prenom, dateNaissance: form.dateNaissance,
        }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.message);
      navigate("/login");
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  };

  const topFields = [
    { name: "prenom",        label: "Prénom",            type: "text",  ph: "Jean",           half: true },
    { name: "nom",           label: "Nom",               type: "text",  ph: "Dupont",         half: true },
    { name: "dateNaissance", label: "Date de naissance", type: "date",  ph: "",               half: false },
    { name: "username",      label: "Nom d'utilisateur", type: "text",  ph: "jean123",        half: false },
    { name: "email",         label: "Email",             type: "email", ph: "jean@email.com", half: false },
  ];

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <span className="eyebrow">Rejoindre Starting Five</span>
          <h1 style={{
            color: "var(--accent)", fontFamily: "var(--font-display)",
            WebkitTextStroke: "1.5px var(--ink)", textShadow: "3px 3px 0 var(--ink)",
            fontSize: "2.5rem", lineHeight: 1.05,
          }}>Créer un compte</h1>
        </div>

        <div className="brut-card p-8">
          {error && (
            <div className="mb-5 p-3 rounded-lg text-sm font-bold"
              style={{ background: "#fee2e2", border: "2px solid #dc2626", color: "#991b1b" }}>
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4">
              {topFields.map((f) => (
                <div key={f.name} className={f.half ? "" : "col-span-2"}>
                  <label className="brut-label">{f.label} *</label>
                  <input name={f.name} type={f.type} value={form[f.name]}
                    onChange={handleChange} required placeholder={f.ph}
                    className="brut-input" />
                </div>
              ))}

     
              <div className="col-span-2">
                <label className="brut-label">Mot de passe *</label>
                <input name="password" type="password" value={form.password}
                  onChange={handleChange} required placeholder="••••••••"
                  className="brut-input" />

       
                {form.password.length > 0 && (
                  <div className="mt-2">
                    <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                      {[1,2,3,4].map((i) => (
                        <div key={i} style={{
                          flex: 1, height: 5, borderRadius: 4,
                          background: i <= strength.score ? strength.color : "#e5e7eb",
                          transition: "background 0.2s",
                        }} />
                      ))}
                    </div>
                    <span style={{ fontSize: "0.78rem", fontWeight: 700, color: strength.color }}>
                      {strength.label}
                    </span>
                  </div>
                )}


                {form.password.length > 0 && (
                  <ul style={{ marginTop: 8, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 4 }}>
                    {rulesState.map((r) => (
                      <li key={r.key} style={{
                        display: "flex", alignItems: "center", gap: 6,
                        fontSize: "0.78rem", fontWeight: 600,
                        color: r.ok ? "#16a34a" : "#6b7280",
                      }}>
                        <span style={{ fontSize: "0.85rem" }}>{r.ok ? "✅" : "⭕"}</span>
                        {r.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

         
              <div className="col-span-2">
                <label className="brut-label">Confirmer le mot de passe *</label>
                <input name="confirmPassword" type="password" value={form.confirmPassword}
                  onChange={handleChange} required placeholder="••••••••"
                  className="brut-input"
                  style={{ borderColor: form.confirmPassword && form.confirmPassword !== form.password ? "#dc2626" : undefined }} />
                {form.confirmPassword && form.confirmPassword !== form.password && (
                  <p style={{ color: "#dc2626", fontSize: "0.78rem", fontWeight: 700, marginTop: 4 }}>
                    ⚠️ Les mots de passe ne correspondent pas
                  </p>
                )}
              </div>
            </div>


            <div className="mt-5 p-4 rounded-xl" style={{ background: "var(--bg)", border: "2.5px solid var(--border)" }}>
              <p style={{ fontWeight: 700, fontSize: "0.82rem", marginBottom: 8, color: "var(--ink)" }}>
                🤖 Vérification humaine
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <span style={{
                  fontFamily: "monospace", fontSize: "1.3rem", fontWeight: 800,
                  letterSpacing: "0.1em", color: "var(--primary)",
                  background: "var(--bg-card)", padding: "6px 14px",
                  border: "2px solid var(--border)", borderRadius: 8,
                  userSelect: "none",
                }}>
                  {captcha.question} = ?
                </span>
                <input type="text" inputMode="numeric" value={captchaInput}
                  onChange={(e) => { setCaptchaInput(e.target.value); setCaptchaError(false); }}
                  placeholder="Votre réponse"
                  style={{
                    width: 110, padding: "8px 12px", fontWeight: 700, fontSize: "1rem",
                    border: `2.5px solid ${captchaError ? "#dc2626" : "var(--border)"}`,
                    borderRadius: 8, background: "var(--bg-card)", color: "var(--ink)",
                    outline: "none",
                  }} />
                <button type="button" onClick={() => { setCaptcha(generateCaptcha()); setCaptchaInput(""); setCaptchaError(false); }}
                  style={{
                    fontSize: "1.2rem", background: "none", border: "none",
                    cursor: "pointer", opacity: 0.6,
                  }} title="Nouvelle question">🔄</button>
              </div>
              {captchaError && (
                <p style={{ color: "#dc2626", fontSize: "0.78rem", fontWeight: 700, marginTop: 6 }}>
                  ⚠️ Mauvaise réponse, essayez à nouveau.
                </p>
              )}
            </div>

            <button type="submit" disabled={loading || !allRulesOk}
              className="brut-btn brut-btn-primary w-full justify-center mt-6"
              style={{ opacity: (!allRulesOk || loading) ? 0.5 : 1, cursor: (!allRulesOk || loading) ? "not-allowed" : "pointer" }}>
              {loading ? "Création..." : "Créer mon compte →"}
            </button>
          </form>

          <p className="text-center text-sm font-medium mt-6" style={{ color: "var(--ink-soft)" }}>
            Déjà un compte ?{" "}
            <Link to="/login" style={{ color: "var(--primary)", fontWeight: 700 }}>Se connecter</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
*/




import { useState, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom";
import API_URL from "../config";

const EyeIcon = ({ open }) => open ? (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
) : (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);





/* ── Règles de mot de passe ── */
const RULES = [
  { key: "length",   label: "8 caractères minimum",      test: (p) => p.length >= 8 },
  { key: "upper",    label: "1 lettre majuscule",         test: (p) => /[A-Z]/.test(p) },
  { key: "digit",    label: "1 chiffre",                  test: (p) => /[0-9]/.test(p) },
  { key: "special",  label: "1 caractère spécial (!@#…)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

function passwordStrength(password) {
  const passed = RULES.filter((r) => r.test(password)).length;
  if (passed <= 1) return { score: 1, label: "Très faible", color: "#dc2626" };
  if (passed === 2) return { score: 2, label: "Faible",      color: "#f59e0b" };
  if (passed === 3) return { score: 3, label: "Moyen",       color: "#3b82f6" };
  return               { score: 4, label: "Fort",        color: "#16a34a" };
}

/* ── CAPTCHA math simple ── */
function generateCaptcha() {
  const a = Math.floor(Math.random() * 10) + 1;
  const b = Math.floor(Math.random() * 10) + 1;
  return { question: `${a} + ${b}`, answer: String(a + b) };
}

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    prenom: "", nom: "", username: "", email: "",
    dateNaissance: "", password: "", confirmPassword: "",
  });
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword]        = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  /* CAPTCHA */
  const [captcha, setCaptcha]       = useState(generateCaptcha);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState(false);

  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  /* Force du mot de passe en temps réel */
  const strength   = useMemo(() => passwordStrength(form.password), [form.password]);
  const rulesState = useMemo(() => RULES.map((r) => ({ ...r, ok: r.test(form.password) })), [form.password]);
  const allRulesOk = rulesState.every((r) => r.ok);

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* Vérif CAPTCHA */
    if (captchaInput.trim() !== captcha.answer) {
      setCaptchaError(true);
      setCaptcha(generateCaptcha());
      setCaptchaInput("");
      return;
    }
    setCaptchaError(false);

    /* Vérif mot de passe */
    if (!allRulesOk) return setError("Le mot de passe ne respecte pas toutes les règles.");
    if (form.password !== form.confirmPassword) return setError("Les mots de passe ne correspondent pas.");

    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: form.username, email: form.email, password: form.password,
          nom: form.nom, prenom: form.prenom, dateNaissance: form.dateNaissance,
        }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.message);
      navigate("/login");
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  };

  const topFields = [
    { name: "prenom",        label: "Prénom",            type: "text",  ph: "Jean",           half: true },
    { name: "nom",           label: "Nom",               type: "text",  ph: "Dupont",         half: true },
    { name: "dateNaissance", label: "Date de naissance", type: "date",  ph: "",               half: false },
    { name: "username",      label: "Nom d'utilisateur", type: "text",  ph: "jean123",        half: false },
    { name: "email",         label: "Email",             type: "email", ph: "jean@email.com", half: false },
  ];

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <span className="eyebrow">Rejoindre Starting Five</span>
          <h1 style={{
            color: "var(--accent)", fontFamily: "var(--font-display)",
            WebkitTextStroke: "1.5px var(--ink)", textShadow: "3px 3px 0 var(--ink)",
            fontSize: "2.5rem", lineHeight: 1.05,
          }}>Créer un compte</h1>
        </div>

        <div className="brut-card p-8">
          {error && (
            <div className="mb-5 p-3 rounded-lg text-sm font-bold"
              style={{ background: "#fee2e2", border: "2px solid #dc2626", color: "#991b1b" }}>
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4">
              {topFields.map((f) => (
                <div key={f.name} className={f.half ? "" : "col-span-2"}>
                  <label className="brut-label">{f.label} *</label>
                  <input name={f.name} type={f.type} value={form[f.name]}
                    onChange={handleChange} required placeholder={f.ph}
                    className="brut-input" />
                </div>
              ))}

              {/* Mot de passe */}
              <div className="col-span-2">
                <label className="brut-label">Mot de passe *</label>
                <div style={{ position: "relative" }}>
                  <input name="password" type={showPassword ? "text" : "password"} value={form.password}
                    onChange={handleChange} required placeholder="••••••••"
                    className="brut-input" style={{ paddingRight: "2.8rem" }} />
                  <button
                    type="button"
                    onClick={() => setShowPassword(v => !v)}
                    style={{
                      position: "absolute", right: "0.75rem", top: "50%", transform: "translateY(-50%)",
                      background: "none", border: "none", cursor: "pointer",
                      color: "var(--ink-soft)", display: "flex", alignItems: "center", padding: 0,
                    }}
                    aria-label={showPassword ? "Masquer" : "Afficher"}
                  >
                    <EyeIcon open={showPassword} />
                  </button>
                </div>

                {/* Barre de force */}
                {form.password.length > 0 && (
                  <div className="mt-2">
                    <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                      {[1,2,3,4].map((i) => (
                        <div key={i} style={{
                          flex: 1, height: 5, borderRadius: 4,
                          background: i <= strength.score ? strength.color : "#e5e7eb",
                          transition: "background 0.2s",
                        }} />
                      ))}
                    </div>
                    <span style={{ fontSize: "0.78rem", fontWeight: 700, color: strength.color }}>
                      {strength.label}
                    </span>
                  </div>
                )}

                {/* Règles */}
                {form.password.length > 0 && (
                  <ul style={{ marginTop: 8, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 4 }}>
                    {rulesState.map((r) => (
                      <li key={r.key} style={{
                        display: "flex", alignItems: "center", gap: 6,
                        fontSize: "0.78rem", fontWeight: 600,
                        color: r.ok ? "#16a34a" : "#6b7280",
                      }}>
                        <span style={{ fontSize: "0.85rem" }}>{r.ok ? "✅" : "⭕"}</span>
                        {r.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Confirmer */}
              <div className="col-span-2">
                <label className="brut-label">Confirmer le mot de passe *</label>
                <div style={{ position: "relative" }}>
                  <input name="confirmPassword" type={showConfirmPassword ? "text" : "password"} value={form.confirmPassword}
                    onChange={handleChange} required placeholder="••••••••"
                    className="brut-input"
                    style={{
                      paddingRight: "2.8rem",
                      borderColor: form.confirmPassword && form.confirmPassword !== form.password ? "#dc2626" : undefined
                    }} />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(v => !v)}
                    style={{
                      position: "absolute", right: "0.75rem", top: "50%", transform: "translateY(-50%)",
                      background: "none", border: "none", cursor: "pointer",
                      color: "var(--ink-soft)", display: "flex", alignItems: "center", padding: 0,
                    }}
                    aria-label={showConfirmPassword ? "Masquer" : "Afficher"}
                  >
                    <EyeIcon open={showConfirmPassword} />
                  </button>
                </div>
                {form.confirmPassword && form.confirmPassword !== form.password && (
                  <p style={{ color: "#dc2626", fontSize: "0.78rem", fontWeight: 700, marginTop: 4 }}>
                    ⚠️ Les mots de passe ne correspondent pas
                  </p>
                )}
              </div>
            </div>

            {/* CAPTCHA */}
            <div className="mt-5 p-4 rounded-xl" style={{ background: "var(--bg)", border: "2.5px solid var(--border)" }}>
              <p style={{ fontWeight: 700, fontSize: "0.82rem", marginBottom: 8, color: "var(--ink)" }}>
                🤖 Vérification humaine
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <span style={{
                  fontFamily: "monospace", fontSize: "1.3rem", fontWeight: 800,
                  letterSpacing: "0.1em", color: "var(--primary)",
                  background: "var(--bg-card)", padding: "6px 14px",
                  border: "2px solid var(--border)", borderRadius: 8,
                  userSelect: "none",
                }}>
                  {captcha.question} = ?
                </span>
                <input type="text" inputMode="numeric" value={captchaInput}
                  onChange={(e) => { setCaptchaInput(e.target.value); setCaptchaError(false); }}
                  placeholder="Votre réponse"
                  style={{
                    width: 110, padding: "8px 12px", fontWeight: 700, fontSize: "1rem",
                    border: `2.5px solid ${captchaError ? "#dc2626" : "var(--border)"}`,
                    borderRadius: 8, background: "var(--bg-card)", color: "var(--ink)",
                    outline: "none",
                  }} />
                <button type="button" onClick={() => { setCaptcha(generateCaptcha()); setCaptchaInput(""); setCaptchaError(false); }}
                  style={{
                    fontSize: "1.2rem", background: "none", border: "none",
                    cursor: "pointer", opacity: 0.6,
                  }} title="Nouvelle question">🔄</button>
              </div>
              {captchaError && (
                <p style={{ color: "#dc2626", fontSize: "0.78rem", fontWeight: 700, marginTop: 6 }}>
                  ⚠️ Mauvaise réponse, essayez à nouveau.
                </p>
              )}
            </div>

            <button type="submit" disabled={loading || !allRulesOk}
              className="brut-btn brut-btn-primary w-full justify-center mt-6"
              style={{ opacity: (!allRulesOk || loading) ? 0.5 : 1, cursor: (!allRulesOk || loading) ? "not-allowed" : "pointer" }}>
              {loading ? "Création..." : "Créer mon compte →"}
            </button>
          </form>

          <p className="text-center text-sm font-medium mt-6" style={{ color: "var(--ink-soft)" }}>
            Déjà un compte ?{" "}
            <Link to="/login" style={{ color: "var(--primary)", fontWeight: 700 }}>Se connecter</Link>
          </p>
        </div>
      </div>
    </div>
  );
}